/* eslint-disable */ import { assertString, attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaGrillW36Components = [
    attachComponent.withComponent(attributeSelectionComponent, 'variant', true).withEntity('LynxSedonaGrillW36').attach(memoEval((self)=>[
            self.variant
        ], (variant)=>({
            value: variant,
            options: [
                {
                    label: '3 SS Burners',
                    value: 'SsBurner3'
                },
                {
                    label: '1 ProSear & 2 SS Burners',
                    value: 'ProSear_SsBurner2'
                },
                {
                    label: '3 SS Burners & Rotisserie',
                    value: 'SsBurner3_Rotisserie'
                },
                {
                    label: '1 ProSear, 2 SS Burners, & Rotisserie',
                    value: 'ProSear_SsBurner2_Rotisserie'
                }
            ]
        })), (state)=>{
        assertString(state.value);
        return {
            variant: state.value
        };
    })
];

//# sourceMappingURL=lynx-sedona-grill-w-36.js.map